export const getCount = ({ reportsReducer: { count = 0 } = {} }) => count;

export const getReports = ({ reportsReducer: { reports = [] } = {} }) =>
  reports;
export const getReportsFilters = ({
  reportsReducer: { filters = {} } = {},
}) => filters;
